<template>
  <div id="management-user" class="table-section">
    <div class="query-section">
      <el-card class="box-card" shadow="never">
        <el-form :inline="true" :model="searchParams" class="form-inline" >
          <el-form-item label="用户名">
            <el-input v-model.trim="searchParams.agentName" placeholder="用户名" />
          </el-form-item>
          <el-form-item label="队列名">
            <el-input v-model.trim="searchParams.workQueueName" placeholder="队列名" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="" @click="clear">清空</el-button>
          </el-form-item>
          <el-button style="float: right;"  type="primary" @click="newUser">新增</el-button>
        </el-form>
        <!-- <div class="button-area"> -->
          <!-- <el-button
            
            type="default"
            @click="bundleAddUser = true"
          >批量新增</el-button> -->
          <!-- <el-button  type="primary" @click="newUser">新增</el-button> -->

          <!-- <el-drawer
            :visible.sync="bundleAddUser"
            title="批量新增用户"
          >
            <el-upload
              ref="upload"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              :file-list="fileList"
              :auto-upload="false"
              :limit="1"
              :action="path"
              class="upload"
            >
              <el-button
                slot="trigger"
                type="primary"
              >选取文件</el-button>
              <el-button
                style="margin-left: 10px;"
                type="success"
                @click="submitUpload"
              >上传到服务器</el-button>
              <div
                slot="tip"
                class="el-upload__tip"
              >只能上传excel文件</div>
            </el-upload>
          </el-drawer> -->
        <!-- </div> -->
      </el-card>
    </div>

    <div class="table-section">
      <el-table :data="manageUserList" :header-row-style="headerRowStyle" border highlight-current-row
        max-height="550px" style="width: 100%">
        <el-table-column prop="id" label="用户id" width="80px">
          <template slot-scope="scope">
            <router-link :to="{ name: 'manage-user-info', params: { uid: scope.row.id } }">{{ scope.row.id
              }}</router-link>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="用户姓名" />
        <el-table-column prop="mobile" label="手机号" />
        <el-table-column prop="email" label="邮箱" />
        <el-table-column label="角色为">

          <template slot-scope="scope">
            <span>{{ userRoleList.filter((item) => item.value == scope.row.role)[0].label }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="workQueueName" label="队列" />
        <el-table-column prop="status_name" label="状态">

          <template slot-scope="scope">
            <span>{{ scope.row.status == '0' ? '启用' : '禁用' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="count" label="案件数" />
      </el-table>
    </div>

    <div class="pagination-section">
      <el-pagination :page-size="pageSize" :page-sizes="[5, 10, 15, 20]" :total="manageUserListTotalCount"
        layout="total, sizes, prev, pager, next" @current-change="changePage" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as manageApi from '../../api/manage.js'
import { getDictionaryList } from "@/api/manage";

export default {
  name: 'management-user-list',
  data() {
    return {
      headerRowStyle: {
        'background-color': '#6584b4'
      },
      searchParams: {},
      pageSize: 10,
      page: 1,
      bundleAddUser: false,
      fileList: [],
      path: process.env.BASE_API,
      userRoleList: []
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'manageUserList',
      'manageUserListTotalCount'
    ]),
    type() {
      return this.$route.query.type
    }
  },
  watch: {
    type: function(val, oldVal) {
      this.clear()
      this.loadUsers()
    }
  },
  async created() {
    // 用户角色
    const fdRoleRes = await getDictionaryList("fd_role");
    fdRoleRes.data.map((item) => {
      this.userRoleList.push({
        label: item.dictLabel,
        value: item.dictValue,
      });
    });
    this.path = process.env.BASE_API + manageApi.updatedLink
    this.loadUsers()
  },
  methods: {
    ...mapActions([
      'fetchManageUserList'
    ]),
    loadUsers() {
      this.searchParams.userId = this.currentUser.id
      this.fetchManageUserList({ searchParams: this.searchParams, current: this.page, size: this.pageSize, queueType: this.type })
    },
    changePage(currentPage) {
      this.page = currentPage
      this.loadUsers()
    },
    search() {
      this.page = 1
      this.loadUsers()
    },
    clear() {
      this.searchParams = {}
    },
    newUser() {
      this.$router.push({ name: 'manage-user-info' })
    },
    submitUpload() {
      this.$refs.upload.submit()
      console.log(this.$refs.upload.file)
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      console.log(file)
    },
    handleSuccess(response) {
      console.log(response)
      if (response.data === 'success') {
        this.$notify({
          title: '上传成功！',
          type: 'success',
          duration: 5000
        })
      } else {
        this.$notify.error({
          title: '出错了！',
          message: response.msg,
          type: 'error',
          duration: 5000
        })
      }
    }
  }
}
</script>
